<template>
  <v-container>
    <v-sheet>
      <v-toolbar dense elevation="0">
        <v-toolbar-title class="subtitle-2 text-capitalize">
          My Applications
        </v-toolbar-title>
        <v-spacer />
      </v-toolbar>
      <v-divider />
      <router-view name="view" />
    </v-sheet>
  </v-container>
</template>

<script>
export default {
  name: "Application",
};
</script>

<style scoped></style>
